// Disable SSR for SPA mode
export const ssr = false;
export const prerender = false;
